import { ImageOriginCollectionName } from '../types.js';
export const mapCollectionName = {
    [ImageOriginCollectionName.Content]: 'content',
    [ImageOriginCollectionName.Products]: 'product',
    [ImageOriginCollectionName.Reviews]: 'review',
    [ImageOriginCollectionName.SecondChance]: 'second_chance_product',
};
export const getCollectionName = (collectionName) => {
    return (collectionName && mapCollectionName[collectionName]) || 'content';
};
//# sourceMappingURL=mapCollectionName.js.map